<div class="md:w-[510px] w-[350]  flex justify-start items-start p-0 flex-wrap gap-0">
  <div class="w-full bg-custom-bg-gray-3 rounded-lg shadow-none mt-0 pt-8">

    @if (loginForm) {
      <form [formGroup]="loginForm" nz-form [nzLayout]="'vertical'" class="px-8 pb-8 pt-0">
        <svg
          class="w-[20px] h-[20px] text-custom-gray cursor-pointer ml-auto hover:text-gray-600 transition"
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
          (click)="dialogRef.close()"
        >
          <path
            d="M6 6L18 18M18 6L6 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        <nz-form-item>
          <nz-form-control [nzErrorTip]="errorsStr['login']?.[0]">
            <nz-form-label
              [nzFor]="'emailOrPhone'"
              nzRequired
              class="!mb-1 !text-[14px] !p-0 !font-normal !text-custom-black"
            >
              Email / Телефон
            </nz-form-label>
            <input
              nz-input
              formControlName="login"
              id="emailOrPhone"
              type="text"
              placeholder="+373 ••• •• ••"
              class="w-full border border-custom-gray-stroke rounded-md bg-custom-bg-gray-2 px-4 py-3 text-[16px] font-normal focus:border-custom-red focus:ring-0 transition"
            />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="!mb-2">
          <nz-form-label
            [nzFor]="'password'"
            nzRequired
            class="!mb-1 !text-[16px] !p-0 !font-normal !text-custom-black"
          >
            Пароль
          </nz-form-label>
          <nz-form-control [nzErrorTip]="errorsStr['password']?.[0]">
            <nz-input-group class="!rounded-md" [nzSuffix]="suffixIcon">
              <input
                formControlName="password"
                id="password"
                [type]="passwordShow ? 'text' : 'password'"
                class="w-full border !border-custom-gray-stroke !rounded-md bg-custom-bg-gray-2 !px-4 !py-3 text-[16px] font-normal focus:border-custom-red focus:ring-0 transition"
              />
            </nz-input-group>
            <ng-template #suffixIcon>
              <button
                type="button"
                class="border-0 bg-transparent p-0 m-0 cursor-pointer"
                (click)="passwordShow = !passwordShow"
                tabindex="-1"
              >
                <i
                  nz-icon
                  [nzType]="passwordShow ? 'eye-invisible' : 'eye'"
                  nzTheme="outline"
                ></i>
              </button>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <div class="flex items-center justify-between mb-4">
          <label nz-checkbox formControlName="rememberMe" class="text-[15px] font-normal text-custom-black-2 select-none">
            Запомнить пароль
          </label>
        </div>
        @if (errorMessage()) {
          <p class="text-custom-red text-[16px] md:w-[340px] w-[310px] my-3"
          >{{errorMessage()}}</p>
        }
        <div class="flex items-center justify-between gap-4">
          <button
            (click)="login()"
            nz-button
            nzType="primary"
            [disabled]=" loginForm.invalid"
            class="w-[180px] h-[48px] bg-custom-red text-white text-[18px] font-medium rounded-md hover:bg-[#c51a1f] transition disabled:opacity-60"
          >
            <ng-container *ngIf="isLoading() === true; else loginText">Входим…</ng-container>
            <ng-template #loginText>Войти</ng-template>
          </button>
          <a  (click)="forgotPassword()" class="text-link-blue text-[16px] font-normal font-rubik hover:underline transition text-right">
            Забыли пароль?
          </a>
        </div>
      </form>

    }
  </div>
</div>
